<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 16" fill="none" {...$$restProps}>
	<path
		d="M5.50703 4.6941C5.26328 4.93785 5.26328 5.3316 5.50703 5.57535L7.93203 8.00035L5.50703 10.4253C5.26328 10.6691 5.26328 11.0628 5.50703 11.3066C5.75078 11.5504 6.14453 11.5504 6.38828 11.3066L9.25703 8.43785C9.38522 8.30966 9.67624 7.97246 9.67624 7.97246C9.67624 7.97246 9.37259 7.67216 9.25703 7.5566L6.38828 4.68785C6.15078 4.45035 5.75078 4.45035 5.50703 4.6941Z"
		fill="currentColor"
	/>
</svg>
